<template>
    <RentalsListingsShell>

        <HugeSpinner v-if="loadingListingDetails"/>
        
        <div v-else>
            <CardShell>
                <DisplayToolCore :tool="listing" route="/active-listings" linkText="Active Listings"/>
            </CardShell>
            
            <PeerCard :user="user" :isVisible="true" class="mt3 mt4-ns"/>
            
            <PricingCard class="mt3 mt4-ns" :rates="listing.rates" :dailyRate="listing.dailyRate" />

            <ActionBar :fixed="true" :style="{ 'height': '80px' }">
                <div class="container w-100">
                    <div class="flex items-center justify-end">
                        <div class="no-underline w-50 w-30-m">
                            <BlackButton @click="showWarning = true" >Deactivate Listing</BlackButton>
                        </div>
                        <router-link class="no-underline w-50 w-30-m ml3 ml4-ns" :to="'/edit-listing-menu/' + listing.id">
                            <TooliabaButton >Edit Listing</TooliabaButton>
                        </router-link>
                    </div>
                </div>
            </ActionBar>

            <!-- deactivate listing warning -->
            <OverlayWarning :showWarning="showWarning">
                <DeactivateListing :listingID="listing.id" @cancel="showWarning = false"/>
            </OverlayWarning>
        </div>
       
        
    </RentalsListingsShell>
</template>

<script>
import RentalsListingsShell from '@/components/rentalsListings/shared/RentalsListingsShell.vue';
import CardShell from '@/components/global/CardShell.vue';
import DisplayToolCore from '@/components/global/displayToolCore/DisplayToolCore.vue';
import PeerCard from '@/components/rentalsListings/shared/PeerCard.vue';
import PricingCard from '@/components/rent/listingDetail/pricingCard/PricingCard.vue';
import ActionBar from '@/components/global/ActionBar.vue';
import BlackButton from '@/components/buttons/BlackButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import DeactivateListing from '@/components/editListing/popups/DeactivateListing.vue';
import OverlayWarning from '@/components/global/OverlayWarning.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            showWarning: false
        };
    },
    computed: {
        ...mapState('listingDetail', [
            'listing',
            'user',
            'loadingListingDetails'
        ])
    },
    components: {
        RentalsListingsShell,
        CardShell,
        DisplayToolCore,
        PeerCard,
        PricingCard,
        ActionBar,
        BlackButton,
        TooliabaButton,
        DeactivateListing,
        OverlayWarning,
        HugeSpinner
    },
    methods: {
        ...mapActions('listingDetail', ['getListingDetail'])
    },
    watch: {
        $route() {
            this.getListingDetail(this.$route.params.id);
        }
    },
    created: function() {
        this.getListingDetail(this.$route.params.id);
    }
};
</script>
